import { useTranslation } from 'react-i18next';

function SkeletonKpiReport() {
  return (
    <div className="report-kpi">
      <div className="report-kpi__header">
        <div className="report-kpi__icon report-kpi__icon--skeleton" />
        <h4 className="report-kpi__title report-kpi__title--skeleton" />
      </div>
      <div className="report-kpi__body">
        <p className="report-kpi__value report-kpi__value--skeleton" />
      </div>
    </div>
  );
}

function Spinner(props) {
  const { text = 'Gerando o relatório' } = props;

  return (
    <div className="loader-spinner-wrapper">
      {text && <p className="loader-spinner-wrapper__text">{text}</p>}
      <div className="loader-spinner" />
    </div>
  );
}

function Loader() {
  const { t } = useTranslation();
  return (
    <div className="loader-container">
      <div className="loader"></div>
      <div className="loader-text">{t('loader.loading')}</div>
    </div>
  );
}

Loader.Spinner = Spinner;
Loader.SkeletonKpiReport = SkeletonKpiReport;

export default Loader;
